// Hook for managing sidebar state with localStorage persistence
import { useState, useEffect } from 'react';

const STORAGE_KEY = 'chat-sidebar-collapsed';

export const useSidebarState = (defaultCollapsed = false) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    // Initialize from localStorage if available
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored !== null) {
        return JSON.parse(stored);
      }
    }
    return defaultCollapsed;
  });

  // Persist to localStorage whenever state changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(isCollapsed));
    }
  }, [isCollapsed]);

  const toggleSidebar = () => {
    setIsCollapsed(prev => !prev);
  };

  const setSidebarCollapsed = (collapsed: boolean) => {
    setIsCollapsed(collapsed);
  };

  return {
    isCollapsed,
    toggleSidebar,
    setSidebarCollapsed
  };
};